module.exports = {
    "collectionLabel": `Ehdotukset`
};


//# sourceMappingURL=fi-FI.main.js.map
